import EnvironmentBanner from '../headers/EnvironmentBanner';
import { ReactElement } from 'react';
import PageHeader from '../headers/PageHeader';
import usePageHeader from '../../hooks/navigation/usePageHeader';

interface Props {
  children: ReactElement;
  header?: JSX.Element;
  headerClassName?: string;
  className?: string;
}

const PageLayout = (props: Props): JSX.Element => {
  const { children, header, className, headerClassName } = props;
  const { showEnvBanner } = usePageHeader();

  return (
    <>
      <div id="page-header" className={headerClassName}>
        {showEnvBanner && <EnvironmentBanner />}
        {header ?? <PageHeader />}
      </div>
      <div className={className}>{children}</div>
    </>
  );
};

export default PageLayout;
